// =============================================
// useDnsChangeLog — ostatnie 100 wpisow dns_change_log + filtr po domenie
// (debounce 300 ms) + refresh. Zakladka "Historia" w /cloudflare.
// =============================================
import { useCallback, useEffect, useState } from "react";
import { listDnsChangeLog, type DnsChangeLogRow } from "@/services/cloudflare/dnsChangeLogService";

export function useDnsChangeLog(limit = 100) {
  const [rows, setRows] = useState<DnsChangeLogRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [domainFilter, setDomainFilter] = useState("");
  const [debounced, setDebounced] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setDebounced(domainFilter), 300);
    return () => clearTimeout(t);
  }, [domainFilter]);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setRows(await listDnsChangeLog({ limit, domain: debounced }));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, [limit, debounced]);

  useEffect(() => { void refresh(); }, [refresh]);

  return { rows, loading, error, domainFilter, setDomainFilter, refresh };
}
